import styled from "styled-components";
import media from "styled-media-query";

import RightSectionContainer from "../../../components/container/RightSectionContainer";
import { Text } from "@adoptaunabuelo/react-components";
import UnaCartaParaUnAbueloLogo from "../../../assets/logo/UnaCartaParaUnAbuelo";

const Container = styled.div`
	display: flex;
	flex: 1;
	flex-direction: column;
	align-items: flex-end;
	width: 100%;
	padding: 24px 0px 40px;
	${media.lessThan("medium")`
        display: none;
	`}
`;
const PersonalRightContainer = styled.div`
	display: flex;
	flex: 1;
	flex-direction: column;
	width: 388px;
	justify-content: center;
`;
const LogoContainer = styled.div`
	position: relative;
	width: 173px;
	height: 107px;
`;

const PersonalRight = () => {
	return (
		<Container>
			<PersonalRightContainer>
				<Text type="h3" weight="semibold" style={{ marginBottom: 16 }}>
					¡Preséntate!
				</Text>
				<Text type="p">
					Para que la persona mayor a la que escribas sepa quién le
					está enviando tanto cariño, necesitamos algunos datos sobre
					ti.
				</Text>
			</PersonalRightContainer>
			<LogoContainer>
				<UnaCartaParaUnAbueloLogo
					style={{ position: "absolute", bottom: 31, left: 0 }}
					version="2025"
					width={107}
					height={76}
				/>
				<UnaCartaParaUnAbueloLogo
					style={{ position: "absolute", bottom: 0, right: 0 }}
					version="round"
					width={80}
					height={80}
				/>
			</LogoContainer>
		</Container>
	);
};
export default PersonalRight;
